// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `\$dot-color: \$primary_color;
.dot-flashing {
    position: relative;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: \$dot-color;
    color: \$dot-color;
    animation: dotFlashing 1s infinite linear alternate;
    animation-delay: .5s;
}

.dot-flashing::before, .dot-flashing::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
}

.dot-flashing::before {
    left: -15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: \$dot-color;
    color: \$dot-color;
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 0s;
}

.dot-flashing::after {
    left: 15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: \$dot-color;
    color: \$dot-color;
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 1s;
}

@keyframes dotFlashing {
    0% {
        background-color: \$dot-color;
    }
    50%,
    100% {
        background-color: #ebe6ff;
    }
}`, "",{"version":3,"sources":["webpack://./src/ui/Dots/Dots.scss"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,iBAAiB;IACjB,mDAAmD;IACnD,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,MAAM;AACV;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,iBAAiB;IACjB,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,iBAAiB;IACjB,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,4BAA4B;IAChC;IACA;;QAEI,yBAAyB;IAC7B;AACJ","sourcesContent":["$dot-color: $primary_color;\n.dot-flashing {\n    position: relative;\n    width: 10px;\n    height: 10px;\n    border-radius: 5px;\n    background-color: $dot-color;\n    color: $dot-color;\n    animation: dotFlashing 1s infinite linear alternate;\n    animation-delay: .5s;\n}\n\n.dot-flashing::before, .dot-flashing::after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    top: 0;\n}\n\n.dot-flashing::before {\n    left: -15px;\n    width: 10px;\n    height: 10px;\n    border-radius: 5px;\n    background-color: $dot-color;\n    color: $dot-color;\n    animation: dotFlashing 1s infinite alternate;\n    animation-delay: 0s;\n}\n\n.dot-flashing::after {\n    left: 15px;\n    width: 10px;\n    height: 10px;\n    border-radius: 5px;\n    background-color: $dot-color;\n    color: $dot-color;\n    animation: dotFlashing 1s infinite alternate;\n    animation-delay: 1s;\n}\n\n@keyframes dotFlashing {\n    0% {\n        background-color: $dot-color;\n    }\n    50%,\n    100% {\n        background-color: #ebe6ff;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
